import {
  Box,
  Button,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import TablePagination from "@mui/material/TablePagination";
import axios from "axios";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./AnalyticsPage.css";
import { apiURL } from "../Constant";
// Register the components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);
const AnalyticsPage = () => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [monthView, setMonthView] = useState([]);
  const [open, setOpen] = useState(null);
  const [selectedBarData, setSelectedBarData] = useState(null);
  const [analyticsError, setAnalyticsError] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0); // Total number of rows
  const [monthdata, setmonthdata] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(1);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    getAnalytics();
  }, [selectedYear]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getDetailPerMonth(selectedMonth);
  }, [page, rowsPerPage, selectedYear, selectedMonth]);
  //const baseURL = "http://localhost:3045";
  const baseURL =
    "https://atci.abcuniversity.accenture.com/abc-university-apis";
  // fetch the user detail and total count for a specific month
  const getDetailPerMonth = async (month) => {
    try {
      const response = await axios.post(
        `${apiURL}/fetchDetailsPerMonth`,
        {
          month: month,
          year: selectedYear,
          page: page,
          rowsPerPage: rowsPerPage,
        },
        {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      setmonthdata(response.data[0].Data);
      setAnalyticsError(false);
      setTotalRows(response.data[0].totalRows);
    } catch (error) {
      setAnalyticsError(true);
    }
  };
  const getAnalytics = async () => {
    try {
      const response = await axios.post(
        `${apiURL}/yearanalytics`,
        {
          year: selectedYear,
        },
        {
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      setMonthView(response.data);
      setAnalyticsError(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAnalyticsError(true);
    }
  };
  const downloadFile = async () => {
    let year = selectedYear;
    setIsDownloading(true);
    try {
      const response = await axios.get(`${baseURL}/downloadAnalytics/${year}`, {
        responseType: "blob",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");

      if (!link) {
        console.error("Error creating link element");
        return;
      }

      link.href = url;
      link.setAttribute("download", `AnalyticsData_${year}.xlsx`);
      document.body.appendChild(link);

      if (typeof link.click !== "function") {
        console.error("Error: click() method not available");
        return;
      }
      if (response) {
        setIsDownloading(false);
      }
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const fillMissingMonths = () => {
    const filledMonthView = [];
    for (let i = 1; i <= 12; i++) {
      const monthData = monthView
        .map((innerArray) => innerArray.Data.filter((item) => item.month === i))
        .flat(); // Flatten the array of arrays
      const totalViews = monthData.reduce(
        (acc, cur) => acc + cur.total_views,
        0
      );
      const totalViewsByEnterprise = monthData.map((userView) => {
        return {
          enterprise_id: userView.enterprise_id,
          total_views: userView.total_views,
        };
      });
      const uniqueView = monthData.map((user) => user.unique_views);
      //console.log(uniqueView, "uniqueView");
      if (monthData.length > 0) {
        filledMonthView.push({
          year: selectedYear,
          month: i,
          unique_views: uniqueView,
          total_views: totalViews,
          total_views_by_enterprise: totalViewsByEnterprise,
        });
      } else {
        filledMonthView.push({
          year: selectedYear,
          month: i,
          unique_views: 0,
          total_views: 0,
          total_views_by_enterprise: [],
        });
      }
    }
    return filledMonthView;
  };
  const handleBarClick = (event) => {
    const activeElement = event.chart.getElementsAtEventForMode(
      event,
      "nearest",
      { intersect: true },
      true
    )[0];
    if (activeElement) {
      const { index } = activeElement;
      //  console.log("fill", fillMissingMonths()[index]);
      //  getDetailPerMonth(index + 1);
      setSelectedMonth(index + 1);
      setSelectedBarData(fillMissingMonths()[index]);
      setOpen(index);
    }
  };
  const options = {
    scales: {
      y: {
        beginAtZero: true,

        title: {
          display: true,
          text: "Views",
          color: "grey",
          font: {
            weight: "bold",
          },
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Unique and Total Views Bar Chart",
        padding: 20,
        color: "#6e0089a6",
        font: {
          size: 20,
        },
      },
      datalabels: {
        color: "#6e0089",
        anchor: "end",
        align: "top",
        offset: 0,
        font: {
          weight: "bolder",
        },
      },
    },
    responsive: true,
    onClick: handleBarClick,
  };
  // Prepare data for chart
  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const chartData = {
    labels,
    datasets: [
      {
        label: "Unique Views",
        data: fillMissingMonths().map((item) => item.unique_views[0]),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Total Views",
        data: fillMissingMonths().map((item) => item.total_views),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };
  const handleCloseModal = () => {
    setOpen(null);
  };

  return (
    <>
      <div>
        <div>
          <Modal
            open={open !== null}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="custom-modal"
          >
            <Box className="tableWrapper">
              <TableContainer component={Paper} className="tableContainer">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="tableHeaderCell">
                        Enterprise ID
                      </TableCell>
                      <TableCell className="tableHeaderCell">
                        Total Views
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {monthdata &&
                      monthdata.map((item, index) => (
                        <TableRow
                          className="tableRow"
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                          }}
                        >
                          <TableCell className="tableCell">
                            {item.enterprise_id}
                          </TableCell>
                          <TableCell className="tableCell">
                            {item.total_count}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                sx={{
                  "& .MuiTablePagination-input": {
                    marginTop: "-10px", // Apply margin-top
                  },
                }}
                rowsPerPageOptions={[5, 10]}
                component="div"
                count={totalRows}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          </Modal>
        </div>
      </div>
      <div id="date-picker-container">
        <Button
          onClick={downloadFile}
          style={{ height: "30px" }}
          size="small"
          variant="outlined"
          disabled={isDownloading ? true : false}
        >
          {isDownloading ? "Loading..." : "Download"}
        </Button>
        <DatePicker
          selected={new Date(selectedYear, 0, 1)}
          onChange={(date) => setSelectedYear(date.getFullYear())}
          dateFormat="yyyy"
          showYearPicker
          className="yearPicker"
        />
      </div>
      {analyticsError && (
        <Alert severity="error" className="errorAlert">
          <b>Internal Server Error:</b> Please try again with a hard refresh. If
          the issue persists, contact the LIS team for further assistance.
        </Alert>
      )}
      <div className="bar-container">
        <Bar plugins={[ChartDataLabels]} data={chartData} options={options} />
      </div>
    </>
  );
};

export default AnalyticsPage;
